import CareerInfo from "../components/CareerComponents/CareerInfo";
import JobList from "../components/CareerComponents/JobList";
import HeroSection from "../components/HeroSection";

import careerHeroImage from '../assets/WhatsApp Image 2025-08-07 at 18.30.24_44785838.jpg'; // Replace with your actual image path

const Career = () => {
    return (
        <>
            <HeroSection
                image={careerHeroImage}
                title={<span>Join <span style={{color:'yellow'}}>Our Team</span> at GreenWorks</span>}
                description={
                    <span style={{ color: 'white' }}>
                        Explore exciting career opportunities and be part of a team that drives sustainable change.
                    </span>
                }
            />
            <div
                style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    padding: '20px',
                    backgroundColor: '#f4f4f4',
                }}
            >
                <CareerInfo />
            </div>
            <div>
                <JobList />
            </div>
        </>
    )
}

export default Career;